import { Model } from '@vuex-orm/core'
import Group from '../groups/model'
import Position from '../positions/model'
import Organization from '../organizations/model'
import Role from '../roles/model'

export const STATUS_APPROVED = 'APPROVED'
export const STATUS_DECLINED = 'DECLINED'
export const STATUS_IN_REVIEW = 'IN-REVIEW'


export default class UserRole extends Model {
    static get entity () {
        return 'user-roles'
    }

    static fields () {
        return {
            id: this.uid(),
            isMain: this.boolean(false),
            status: this.string(''),
            groupId: this.string(null).nullable(),
            userId: this.string(''),
            positionId: this.string(null).nullable(),
            organizationId: this.string(null).nullable(),

            roleId: this.string(''),
            group: this.belongsTo(Group, 'groupId'),
            position: this.belongsTo(Position, 'positionId'),
            organization: this.belongsTo(Organization, 'organizationId'),
            role: this.belongsTo(Role, 'roleId'),
        }
    }
}
